var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Client } from '@microsoft/microsoft-graph-client';
import { store } from '../../store';
import { authApi } from '../auth/auth-api';
var SITE_ID = process.env.REACT_APP_GRAPH_SITE_ID;
var DRIVE_ID = process.env.REACT_APP_GRAPH_DRIVE_ID;
var getAccessToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, store.dispatch(authApi.endpoints.getMicrosoftGraphToken.initiate())];
            case 1:
                token = (_a.sent()).data;
                return [2 /*return*/, token];
        }
    });
}); };
var getGraphClient = function () { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, graphClient;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAccessToken()];
            case 1:
                accessToken = _a.sent();
                graphClient = Client.init({
                    authProvider: function (done) {
                        done(null, accessToken);
                    }
                });
                return [2 /*return*/, graphClient];
        }
    });
}); };
var getPreviewUrl = function (filePath_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([filePath_1], __read(args_1), false), void 0, function (filePath, page, zoom) {
        var client, previewUrl, response;
        if (page === void 0) { page = '1'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getGraphClient()];
                case 1:
                    client = _a.sent();
                    previewUrl = "/sites/".concat(SITE_ID, "/drives/").concat(DRIVE_ID, "/root:/").concat(filePath, ":/preview");
                    return [4 /*yield*/, client.api(previewUrl).post({ page: page, zoom: zoom })];
                case 2:
                    response = _a.sent();
                    if (response.getUrl)
                        return [2 /*return*/, "".concat(response.getUrl, "&nb=true")];
                    else
                        return [2 /*return*/, "".concat(response.postUrl, "&nb=true")];
                    return [2 /*return*/];
            }
        });
    });
};
var getSharingLink = function (filePath) { return __awaiter(void 0, void 0, void 0, function () {
    var client, sharingUrl, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getGraphClient()];
            case 1:
                client = _a.sent();
                sharingUrl = "/sites/".concat(SITE_ID, "/drives/").concat(DRIVE_ID, "/root:/").concat(filePath, ":/createLink");
                return [4 /*yield*/, client.api(sharingUrl).post({
                        type: 'view',
                        scope: 'users'
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.link.webUrl];
        }
    });
}); };
var getDownloadUrl = function (filePath) { return __awaiter(void 0, void 0, void 0, function () {
    var client, downloadUrl, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getGraphClient()];
            case 1:
                client = _a.sent();
                downloadUrl = "/sites/".concat(SITE_ID, "/drives/").concat(DRIVE_ID, "/root:/").concat(filePath, "?select=@microsoft.graph.downloadUrl");
                return [4 /*yield*/, client.api(downloadUrl).get()];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response['@microsoft.graph.downloadUrl']];
        }
    });
}); };
export var graphApi = {
    getPreviewUrl: getPreviewUrl,
    getSharingLink: getSharingLink,
    getDownloadUrl: getDownloadUrl
};
